<template>
    <div class="inputarea-container">
        <textarea
            :value="inputValue"
            @input="keyPressing"
            ref="input"
            :placeholder="$props.placeholder"
            class="padding-sm"
            :class="[customClasses]"
            :disabeld="$props.disabled"/>
    </div>
</template>

<script>
export default {
    name:'inputarea',
    props:{
        placeholder: String,
        disabled: {
            type: Boolean,
            default: false
        },
        customClasses:{
            type:Array,
            default: () => ['bg-mid-black','text-white']
        },
        inputValue:String,
        focusOnMounted: {type: Boolean, required: false, default: false}
    },
    methods:{
        keyPressing(evt){
            this.$emit('keyPressing',evt)
        }
    },
    data(){
        return {
        }
    },
    mounted() {
      if(this.focusOnMounted) {
        this.$refs.input.focus()
      }
    }
}
</script>


<style lang="scss">
@import "./inputarea.scss";
</style>
